"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _GridList = _interopRequireDefault(require("@material-ui/core/GridList"));

var _GridListTile = _interopRequireDefault(require("@material-ui/core/GridListTile"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Fullscreen = _interopRequireDefault(require("@material-ui/icons/Fullscreen"));

var _Overlay = _interopRequireDefault(require("../Overlay"));

var _Placeholder = _interopRequireDefault(require("./Placeholder"));

var _default = function _default(_ref) {
  var images = _ref.images,
      _ref$cellHeight = _ref.cellHeight,
      cellHeight = _ref$cellHeight === void 0 ? 120 : _ref$cellHeight;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-2 py-4"
  }, images.length > 0 ? /*#__PURE__*/_react["default"].createElement(_GridList["default"], {
    cols: 3,
    cellHeight: cellHeight
  }, images.map(function (_ref2, index) {
    var name = _ref2.name,
        image = _ref2.image,
        onClick = _ref2.onClick;
    return /*#__PURE__*/_react["default"].createElement(_GridListTile["default"], {
      key: "".concat(name, "-").concat(index),
      cols: 1,
      className: "!p-2"
    }, /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
      key: name,
      actions: /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-full h-full flex items-center justify-center"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        color: "inherit",
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement(_Fullscreen["default"], {
        fontSize: "large"
      })))
    }, /*#__PURE__*/_react["default"].cloneElement(image, {
      className: 'm-w-lg w-full h-full object-cover absolute inset-0'
    })));
  })) : /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
    src: t('placeholder-photo.png'),
    text: t('contact.detail.photo.empty')
  }));
};

exports["default"] = _default;
//# sourceMappingURL=PhotosView.js.map